import React, { Component } from 'react';

// Delay mounting a component until shouldMountFn(props) returns true

const withDelayedMount = shouldMountFn => BaseComponent => {
  class DelayedMount extends Component {
    constructor(props) {
      super(props);

      this.shouldMount = shouldMountFn(props);
    }

    componentWillUpdate(nextProps) {
      if (!this.shouldMount) {
        this.shouldMount = shouldMountFn(nextProps);
      }
    }

    render() {
      return !!this.shouldMount && <BaseComponent {...this.props} />;
    }
  }

  return DelayedMount;
};

export default withDelayedMount;
